var _path, _path2, _ellipse, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcSignupGoal = function SvgIcSignupGoal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 35,
    fill: "none",
    viewBox: "0 0 28 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5D71",
    d: "M24.82 11.528 11.651 6.389l.05 9.566z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8,
    d: "M26.369 10.89 11.63 5.067l-.014 11.645z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.646,
    cy: 29.809,
    fill: "#3F3F45",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8,
    rx: 8.517,
    ry: 2.839
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.839,
    height: 26.26,
    x: 9.227,
    y: 3.549,
    fill: "#F3D9DA",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8,
    rx: 1.419
  })));
};
export default SvgIcSignupGoal;